<template>
	<div class="my-earnings">

		<div class="my-earnings__heading">My Earnings</div>

		<v-divider class="my-earnings__divider"></v-divider>

		<MyEarningList />


	</div>
</template>



<script setup>

import MyEarningList from "@/components/Earn/MyEarning/MyEarning-List.vue";

</script>